export const replaceConsecutiveSpaces = (str) => {
	return str.replace(/\s\s+/g, ' ');
};

export const stripHTML = (str) => {
	return str.replace(/<[^>]+>/g, '');
};


// WEBPACK FOOTER //
// ./src/utils/string.js